import storage, { StorageType } from '@va/storage'
import Vue from 'vue'

export const db = storage.getInstance(StorageType.Local, '_T&D_portal')

export const $bus = new Vue()
